import { useSearchParams } from 'react-router-dom';

import { PrivateRouteProps } from './types';
import PrivateRoute from './PrivateRoute';
import PrivateRouteMobile from './PrivateRouteMobile';

const PrivateRouteCheck = (props: PrivateRouteProps) => {
  const [searchParams] = useSearchParams();

  const isMobileToken = searchParams.has('isMobileToken');

  if (isMobileToken) return <PrivateRouteMobile {...props} />;

  return <PrivateRoute {...props} />;
};

export default PrivateRouteCheck;
